var FORMULA_CONST = 10000;
var INVOICE_CURRENCIES_EXPONENTS = {
  EUR: 2,
  NOK: 2,
  SEK: 2,
  DKK: 2
};
var DEPENDENT_FIELDS = {
  total_amount: ['quantity', 'unit_price'],
  total_tax_amount: ['total_amount', 'tax_rate'],
  order_tax_amount: ['total_tax_amount']
};
var formulas = {
  total_amount: function total_amount(index, quantity, unit_price, total_discount_amount) {
    var $itemType = $('select[id$="' + index + '_item_type"]').find('option:selected');
    var isDiscountType = $itemType.val() === 'discount';

    if (isDiscountType) {
      return quantity * unit_price;
    }

    return quantity * unit_price - total_discount_amount;
  },
  total_tax_amount: function total_tax_amount(total_amount, tax_rate) {
    var tax = total_amount * FORMULA_CONST / (FORMULA_CONST + Number(tax_rate));
    return total_amount - tax;
  }
};

function getIndex(input) {
  var index = $(input).attr('id').match(/\d+/);
  return index[0];
}

function updateOrderTaxAmount() {
  var total_tax_amounts = 0;
  $('input[id$="total_tax_amount"]').each(function (index, element) {
    total_tax_amounts += Number($(element).val());
  });
  $('input[id$="order_tax_amount"]').val(total_tax_amounts);
}

function updateTotalTaxAmount(input) {
  var index = getIndex(input);
  var $total_tax_amount_input = $('#items_item' + index + '_total_tax_amount');

  if ($('#items_item' + index + '_tax_rate').val() === '') {
    $total_tax_amount_input.val('');
    updateOrderTaxAmount();
    return 0;
  }

  var total_amount = $('#items_item' + index + '_total_amount').val();
  var tax_rate = $('#items_item' + index + '_tax_rate').val();
  var total_tax_amount = formulas.total_tax_amount(total_amount, tax_rate);
  $total_tax_amount_input.val(Math.ceil(total_tax_amount));
  updateOrderTaxAmount();
}

function updateAmount() {
  var amount = 0;
  var currency = $('span.currency').text();
  var exponent = INVOICE_CURRENCIES_EXPONENTS[currency];

  if (currency === '' || typeof exponent === 'undefined') {
    return 0;
  }

  $('input[id$="total_amount"]').each(function (index, element) {
    amount += Number($(element).val());
  });

  if (amount % 1 !== 0) {
    return 0;
  }

  var decimal_amount = amount.toString().slice(-exponent);
  var whole_amount = amount.toString().slice(0, -exponent);
  $('#whole_amount').val(whole_amount);
  $('#decimal_amount').val(decimal_amount);
}

function updateTotalAmountForItem(input) {
  var index = getIndex(input);
  var quantity = $('#items_item' + index + '_quantity').val();
  var unit_price = $('#items_item' + index + '_unit_price').val();
  var total_discount_amount = $('#items_item' + index + '_total_discount_amount').val();
  var total_amount = formulas.total_amount(index, quantity, unit_price, total_discount_amount);
  $('#items_item' + index + '_total_amount').val(total_amount);
  updateAmount();
}

export function listenForDependentFields() {
  $.each(DEPENDENT_FIELDS, function (key, value) {
    $.each(value, function (index, input) {
      var selector = 'select[id$="item_type"], input[id$="' + input + '"]';
      $('#items-container').on('change keyup', selector, function () {
        updateTotalAmountForItem(this);
        updateTotalTaxAmount(this);
      });
    });
  });
}
export function recalculateAmounts() {
  updateAmount();
  updateOrderTaxAmount();
}